import axios from 'axios';

const getApiBaseUrl = () => {
  const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  if (isLocalhost && process.env.REACT_APP_API_URL) {
    return `${process.env.REACT_APP_API_URL}/api`;
  }
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();

const MobileResumeStorageService = {
  saveResume: async (resumeData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/resume/save`, { resumeData }, { withCredentials: true });
      return response.data;
    } catch (error) {
      console.error('Error saving resume:', error);
      throw error;
    }
  },

  loadResume: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/resume/load`, { withCredentials: true });
      return response.data;
    } catch (error) {
      console.error('Error loading resume:', error);
      throw error;
    }
  }
};

export default MobileResumeStorageService;

